import { render, staticRenderFns } from "./realWarehouse.vue?vue&type=template&id=332f92fa&scoped=true"
import script from "./realWarehouse.vue?vue&type=script&lang=js"
export * from "./realWarehouse.vue?vue&type=script&lang=js"
import style0 from "./realWarehouse.vue?vue&type=style&index=0&id=332f92fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332f92fa",
  null
  
)

export default component.exports